// UCSB's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from UCSB's official
// 2026-2027 General Catalog, Programs (catalog.ucsb.edu/programs), which is a
// Coursedog app: the page's own program search (the catalog's default filter,
// active programs) was read in full, 330 programs, and every Bachelor's
// degree kept, grouped by the college the catalog names (its "L&S" entries are
// the College of Letters and Science; "College of Creative Studies" is dropped
// from Creative Studies program names since the group says it). Each emphasis is
// its own catalog line; it is not a separate major, so it sits in the major's
// note. The catalog's Pre- majors (Pre-Economics, Pre-Biology, ...) are entry
// designations, not degrees: left out, and named in the note of the major with
// the same name. Flags and group notes quote UCSB's first-year selection page
// (the college file's `selection` source). The KB's list was the starting
// point; the catalog wins.
const majors = {
    "slug": "university-of-california-santa-barbara",
    "read": "2026-09-30",
    "intro": "Every bachelor's degree in UCSB's official 2026-2027 General Catalog, grouped by the college that offers it, with the degree it leads to. Emphases are listed under their major; pre-majors, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Letters and Science",
            "source": {
                "label": "UCSB General Catalog 2026-2027, Programs",
                "url": "https://catalog.ucsb.edu/programs"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BS",
                    "note": "Students start in the Pre-Actuarial Science pre-major."
                },
                {
                    "name": "Anthropology",
                    "degree": "BA",
                    "note": "Emphases: Archaeology; Biological; Cultural."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS",
                    "note": "Students start in the Pre-Applied Mathematics pre-major."
                },
                {
                    "name": "Aquatic Biology",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biopsychology",
                    "degree": "BS",
                    "note": "Students start in the Pre-Biopsychology pre-major."
                },
                {
                    "name": "Black Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA",
                    "note": "Students start in the Pre-Chemistry pre-major."
                },
                {
                    "name": "Chemistry",
                    "degree": "BS",
                    "note": "Students start in the Pre-Chemistry pre-major."
                },
                {
                    "name": "Chicana and Chicano Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA",
                    "note": "Emphases: Ancient Greek and Roman Philosophy; Classical Archaeology; Classical Language & Literature; Greek and Roman Culture."
                },
                {
                    "name": "Communication",
                    "degree": "BA",
                    "note": "Students start in the Pre-Communication pre-major."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA",
                    "note": "Emphases: Interdisciplinary; Multilingual."
                },
                {
                    "name": "Dance",
                    "degree": "BA",
                    "flag": "An audition is required for dance and music performance majors.",
                    "flagSource": "selection"
                },
                {
                    "name": "Dance",
                    "degree": "BFA",
                    "flag": "An audition is required for dance and music performance majors.",
                    "flagSource": "selection"
                },
                {
                    "name": "Earth Science",
                    "degree": "BA"
                },
                {
                    "name": "Earth Science",
                    "degree": "BS",
                    "note": "Emphases: Geobiology & Paleobiology; Climate and Environment; Geology; Geophysics."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ecology and Evolution",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA",
                    "note": "Students start in the Pre-Economics pre-major."
                },
                {
                    "name": "Economics and Accounting",
                    "degree": "BA",
                    "note": "Students start in the Pre-Economics and Accounting pre-major."
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Feminist Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA",
                    "note": "Students start in the Pre-Film and Media Studies pre-major."
                },
                {
                    "name": "Financial Mathematics and Statistics",
                    "degree": "BS",
                    "note": "Students start in the Pre-Financial Mathematics and Statistics pre-major."
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA",
                    "note": "Emphasis: Geographic Information Science."
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA",
                    "note": "Students start in the Pre-Global Studies pre-major."
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": "BA",
                    "note": "Emphases: Architecture and Environment; Museum Studies."
                },
                {
                    "name": "History of Policy, Law, and Governance",
                    "degree": "BA"
                },
                {
                    "name": "Hydrologic Sciences and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA",
                    "note": "Emphasis: Transnational."
                },
                {
                    "name": "Language, Culture, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Iberian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA",
                    "note": "Emphases: Chinese; English; French; German; Japanese; Language and Speech Technologies; Slavic; Spanish; Speech-Language Sciences and Disorders."
                },
                {
                    "name": "Mathematics",
                    "degree": "BA",
                    "note": "Students start in the Pre-Mathematics pre-major."
                },
                {
                    "name": "Mathematics",
                    "degree": "BS",
                    "note": "Students start in the Pre-Mathematics pre-major."
                },
                {
                    "name": "Medieval Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle East Studies",
                    "degree": "BA"
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "BS",
                    "note": "Emphases: Biochemistry-Molecular Biology; Cell and Developmental Biology; Microbiology; Pharmacology."
                },
                {
                    "name": "Music",
                    "degree": "BM",
                    "note": "Emphases: Bassoon; Cello; Clarinet; Composition; Double Bass; Flute; French Horn; Oboe; Percussion; Piano; Trombone; Trumpet; Tuba; Viola; Violin; Voice.",
                    "flag": "An audition is required for dance and music performance majors.",
                    "flagSource": "selection"
                },
                {
                    "name": "Music Studies",
                    "degree": "BA",
                    "note": "Emphases: Ethnomusicology; Interdisciplinary Studies of Music; Western Art Music."
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physical Geography",
                    "degree": "BS",
                    "note": "Emphasis: Ocean Science."
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA",
                    "note": "Students start in the Pre-Political Science pre-major."
                },
                {
                    "name": "Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Psychological & Brain Sciences",
                    "degree": "BS",
                    "note": "Students start in the Pre-Psychological & Brain Sciences pre-major."
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian and East European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA",
                    "note": "Students start in the Pre-Sociology pre-major."
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BA",
                    "note": "Students start in the Pre-Statistics and Data Science pre-major."
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BS",
                    "note": "Students start in the Pre-Statistics and Data Science pre-major."
                },
                {
                    "name": "Theater",
                    "degree": "BA",
                    "note": "Emphasis: Theater Design."
                },
                {
                    "name": "Theater",
                    "degree": "BFA",
                    "note": "Emphasis: Acting."
                },
                {
                    "name": "Zoology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UCSB General Catalog 2026-2027, Programs",
                "url": "https://catalog.ucsb.edu/programs"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ],
            "note": "Alternate Engineering majors are not considered; to be reviewed for an alternate major, choose one in the College of Letters and Science.",
            "noteSource": "selection"
        },
        {
            "name": "College of Creative Studies",
            "source": {
                "label": "UCSB General Catalog 2026-2027, Programs",
                "url": "https://catalog.ucsb.edu/programs"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry and Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry and Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Marine Science",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music Composition",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Writing and Literature",
                    "degree": "BA"
                }
            ],
            "note": "A supplemental application is required, reviewed by Creative Studies faculty. Pick a second-choice major outside Creative Studies.",
            "noteSource": "selection"
        }
    ]
};

export default majors;
